//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addSwiper from "./components/addSwiper";
export default {
  name: "topBanner",
  mixins: [loadMoreList, serchSelect],
  components: {
    addSwiper: addSwiper
  },
  data: function data() {
    return {
      pagingReqFn: "recodeList",
      pagingReqValue: ""
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {}
};